import React, { createContext, useContext, useRef, useEffect } from 'react'
import { OrderEngineContext } from './OrderEngineContext'
import axios from 'axios'
import okeResponse from 'okeoke.standardresponse'

const OkePaymentCustomerContext = createContext()

const paymentUrl = 'https://payment-dev.app.okeoke.io'

const OkePaymentCustomerProvider = (props) => {
  const { brandID, token } = useContext(OrderEngineContext)
  const tokenRef = useRef(null)
  const brandIDRef = useRef(null)

  const paymentUrlRef = useRef(paymentUrl)

  const getSavedCards = async () => {
    try {
      if(!tokenRef.current) return okeResponse(false, 401, 'Unauthorized.')
      if(!brandIDRef.current) return okeResponse(false, 400, 'Brand ID is required.')
      const response = await axios(paymentUrlRef.current +  '/api/v1/customer/cards', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + tokenRef.current,
          'brandid': brandIDRef.current,
        }
      })
      return response.data
    } catch (e) {
      return okeResponse(false, 500, 'Internal error.', e)
    }
  }

  useEffect(() => {
    if(token) tokenRef.current = token
    if(brandID) brandIDRef.current = brandID
  }, [token, brandID])

  return (
    <OkePaymentCustomerContext.Provider
      value={{
        getSavedCards
      }}
    >
      {props.children}
    </OkePaymentCustomerContext.Provider>
  )
}

export { OkePaymentCustomerContext, OkePaymentCustomerProvider }
